export function getLoadingPagePath(locale: string) {
  return `/${locale}/flights/itinerary/loading`;
} 